/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import axios from 'axios';

// initial state
const state = {
  fuelFunds: null,
  loaders: {
    fuelFunds: false,
  },
};

// getters
const getters = {
  fuelFunds: (state) => state.fuelFunds,
  loaders: (state) => state.loaders,
  accruesFuelFunds: (state) => (state.fuelFunds ? state.fuelFunds.accruesFuelFunds : null),
  credits: (state) => (state.fuelFunds ? state.fuelFunds.credits : null),
  creditsTotal: (state) => (state.fuelFunds ? state.fuelFunds.creditsTotal : null),
  percentages: (state) => (state.fuelFunds ? state.fuelFunds.percentages : null),
  totalAvailable: (state) => (state.fuelFunds ? state.fuelFunds.totalAvailable : null),
  transactions: (state) => (state.fuelFunds ? state.fuelFunds.transactions : null),
  transactionsTotal: (state) => (state.fuelFunds ? state.fuelFunds.transactionsTotal : null),
};

// actions
const actions = {
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },

  /**
   * Loads Fuel Funds and associated metrics
   */
  getFuelFunds({ commit }) {
    if (!state.fuelFunds) {
      commit('TOGGLE_LOADING', { key: 'fuelFunds', value: true });
      return axios.get(`${CONFIG.get('BASE_URL')}/api/fuel-funds/`)
        .then((response) => {
          commit('SET_PROPERTY', { key: 'fuelFunds', value: response.data });
          commit('TOGGLE_LOADING', { key: 'fuelFunds', value: false });
        });
    }
    return;
  },
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
